<template>
  <div id="app" class="inclusionCurriculum">
    <nav-component></nav-component>
    <hero-component></hero-component>
    <intro-component :IntroComponent = "IntroComponent" class="d-none"></intro-component>
    <sub-intro-component></sub-intro-component>
    <resourses-accordian-component></resourses-accordian-component>
    <footer-component></footer-component>
  </div>
</template>

<script>
  import NavComponent from "../components/NavComponent.vue";
  import HeroComponent from "../components/StaticHero.vue";
  import FooterComponent from "../components/FooterComponent.vue";
  import IntroComponent from "../components/introComponent.vue";
  import SubIntroComponent from "../components/subintroComponent.vue";
  import ResoursesAccordianComponent from "../components/resoursesAccordianComponent.vue";  
  import SuccessComponent from "../components/SuccessComponent.vue";
  export default {
    name: "app",
    components: {
      NavComponent,
      HeroComponent,
      FooterComponent,
      IntroComponent,
      SuccessComponent,
      SubIntroComponent,
      ResoursesAccordianComponent,
    },
    data() {
      return {
        currentStep: 0,
        IntroComponent: {
          intoHeader: "SET YOURSELF APART",
          intoHeaderMobile:"SET YOURSELF APART",
          introContent: "To Be Welcoming includes resources that help guide you towards employment and self-sustainability, with on-the-go learning modules that teach the skills you need to thrive in today’s economy. We believe you are the future of our country, and potential is limitless.",
        }
      };
    },
    created() {
      console.log("STORE ACCESS= ",this.$store.state.currentStep)
    }
  };
</script>